import { SwiperSlide } from "swiper/react";

import React from "react";
import { Pagination } from "swiper/modules";
import { Navigation } from "swiper/modules";
import { Swiper } from "swiper/react";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import Image from "next/image";
import SText from "@/components/atoms/SText";
import TruncatedText from "@/components/molecules/TruncatedText/TruncatedText";
import { useTranslation } from "react-i18next";
import { IMAGE_WIDTH_EVENT_CARD } from "@/constants/number";
import { IMAGE_HEIGHT_EVENT_CARD } from "@/constants/number";
type EventCardProps = {
  data: Record<string, string>;
  title: string;
  description: string;
};
const EventCard = (props: EventCardProps) => {
  const { data, title, description } = props;
  const { t } = useTranslation();
  return (
    <div className="bg-white p-6 rounded-lg shadow-md min-h-[424px] h-full">
      <Swiper
        modules={[Navigation, Pagination]}
        navigation
        pagination={{ clickable: true }}
        className="custom-swiper"
      >
        {Object.entries(data).map(([key, src]) => (
          <SwiperSlide key={key}>
            <Image
              quality={100}
              src={src}
              unoptimized
              width={IMAGE_WIDTH_EVENT_CARD}
              height={IMAGE_HEIGHT_EVENT_CARD}
              alt={""}
              priority
              className="w-full h-64 md:h-96 aspect-square object-cover rounded-lg"
            />
          </SwiperSlide>
        ))}
      </Swiper>
      <SText text={t(title)} className="text-gray-700 font-bold my-2" />
      <TruncatedText text={t(description)} />
    </div>
  );
};

export default EventCard;
